import route from 'ziggy-js';

export function useZiggy() {
  return {
    route,
    router: route(),
  };
}
